import axios from 'axios';

interface AccessToken {
  data: {
    accessToken: string;
  };
}

const authenticate = async (accessToken: string, linkedAccounts: any[]) => {
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  const res = await client.post<AccessToken>(`/wallet/auth/privy`, {
    accessToken,
    linkedAccounts
  });

  return res.data.data;
};

export { authenticate };
